import { render, staticRenderFns } from "./CollectionResourceFolder.vue?vue&type=template&id=7e5551b0"
import script from "./CollectionResourceFolder.vue?vue&type=script&lang=js"
export * from "./CollectionResourceFolder.vue?vue&type=script&lang=js"
import style0 from "./CollectionResourceFolder.vue?vue&type=style&index=0&id=7e5551b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports